export default __webpack_public_path__ + "static/media/photo--lg--49.e0176c8e.jpg";